// extracted by mini-css-extract-plugin
export default {"textArea":"DataCollectionEditor_textArea__ure+A","btnStyle":"DataCollectionEditor_btnStyle__MRld2","selectStyle":"DataCollectionEditor_selectStyle__tDBeC"};